import { AuthAdapter, OtpSession, VerifyResult } from './authAdapter'
import { apiClient } from '../../lib/api'

/**
 * Local OTP Adapter
 * Uses backend API endpoints for OTP sending and verification
 * Used for development/testing without Firebase
 */
export class LocalOtpAuthAdapter implements AuthAdapter {
  async sendOtp(phone: string, verifier?: any): Promise<OtpSession> {
    try {
      const response = await apiClient.post('/auth/send-otp', { phone })
      if ((response.data as any).success) {
        const data = (response.data as any).data
        return {
          sessionId: data.sessionId,
          phone: data.phone,
          otp: data.otp // Only included in development
        }
      } else {
        throw new Error((response.data as any).error || 'Failed to send OTP')
      }
    } catch (error: any) {
      console.error('Error sending OTP:', error)
      const errorMessage = error.response?.data?.error || error.message || 'Failed to send OTP'
      throw new Error(errorMessage)
    }
  }

  async verifyOtp(sessionId: string, otp: string): Promise<VerifyResult> {
    try {
      const response = await apiClient.post('/auth/verify-otp', { sessionId, otp })
      if ((response.data as any).success) {
        const data = (response.data as any).data
        return {
          sessionId: data.sessionId,
          phone: data.phone,
          exists: data.exists,
          availableRoles: data.availableRoles || []
        }
      } else {
        throw new Error((response.data as any).error || 'Invalid OTP')
      }
    } catch (error: any) {
      console.error('Error verifying OTP:', error)
      const errorMessage = error.response?.data?.error || error.message || 'Invalid OTP'
      throw new Error(errorMessage)
    }
  }
}

